/* eslint-disable no-underscore-dangle */
import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import MeetingModel from '@/models/meeting';
import s from './index.less';
import ReactionModel from '@/models/reaction';
import { meeting, rtc } from '@/models';
import EmoItem from '../EmoItem';
import EmoLoading from '../EmoLoading/inde';
import EmoError from '../EmoError';
interface EmojListProps {
  meeting?: MeetingModel;
  reaction?: ReactionModel;
  hostEnableEmoList: boolean;
}

const EmojList: React.FC<EmojListProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    reaction: store.reaction,
  };
})(
  observer((props) => {
    const { reaction, hostEnableEmoList } = props;
    const { formatMessage } = useIntl();
    const panelRef = useRef<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const staticEmoList = reaction?.staticEmoList || [];
    const fetchEmojeList = () => {
      if (staticEmoList.length) {
        return;
      }
      if (loading) {
        return;
      }
      setLoading(true);
      API.api.reaction.getEmoticons
        .request({ channelId: meeting.info?.channelId })
        .then((res) => {
          const urlPrefix = res?.data?.urlPrefix;
          if (res?.data?.emoticons) {
            const imgUrlList = res?.data?.emoticons.map((item) => {
              return {
                emoticonName: item.emoticonName,
                defaultUrl: `${urlPrefix}/${item.staticWebpSuffix}?fop=imageView/2/w/128`,
                animateUrl: `${urlPrefix}/${item.animationWebpSuffix}?fop=imageView/2/w/128`,
                ...item,
              };
            });
            reaction?.setStaticEmoList(imgUrlList);
          }

          setLoading(false);
        })
        .catch((err) => {
          setError(true);
          setLoading(false);
        });
    };

    useEffect(() => {
      if (meeting.info?.channelId) {
        fetchEmojeList();
      }
    }, []);

    return (
      <div className={classnames(s.container, !hostEnableEmoList ? s.disable : '')}>
        {loading && <EmoLoading></EmoLoading>}
        {!loading && error && <EmoError reload={fetchEmojeList}></EmoError>}
        {!loading &&
          !error &&
          staticEmoList?.length &&
          staticEmoList.map((item, index) => (
            <EmoItem hostEnableEmoList={hostEnableEmoList} emo={item} key={index}></EmoItem>
          ))}
      </div>
    );
  })
);
export default EmojList;
